import { AbstractPmsApiService } from './abstract.service';
import { Property } from '../models';

export class CreditCardPasswordPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/auth/credit-card-password';
    }

    resolveToken(token) {

        const url = this.url();
        const params = {token: token};

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @return {Promise.<boolean>}
     * @param property
     */
    reset(property = {}) {

        const url = this.url();

        const data = {
            property: property.id || null
        };

        return this.http
            .post(url, data, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {{token: string, password: string, password_confirmation: string}} credentials
     * @return {Promise.<boolean>}
     */
    restore(credentials) {

        const url = this.url();

        return this.http
            .put(url, credentials, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    properties() {

        const url = `${this.url()}/properties`;

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(response => this.extractData(response).map(attributes => new Property(attributes)))
            .catch(this.getErrorHandler());
    }

    hasPassword() {

        const url = `${this.url()}/has-password`;

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .then(({has_password})=> Boolean(has_password))
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/credit-card-password.service.js